import filterConfig from "../config/problemCreatorFilters.js";

import filterAbstract from "./filterAbstract.js";

export default filterAbstract(filterConfig);
